import superagent, { Request, Response } from 'superagent'
import { ApolloClient, InMemoryCache, createHttpLink, DefaultOptions } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import resolvers from './resolvers'

let token = ''

const getAPIHost = () => process.env.REACT_APP_MOVE_API_URL || '' // empty string => default to use local proxy

const API_ROOT = (version: number) => `${getAPIHost()}/api/${version}`
const GQL_ROOT = () => `${getAPIHost()}/graphql`

const getEndpoint = (path: string, version = 1) => `${API_ROOT(version)}${path}`
const responseBody = (res: Response) => res.body

const httpLink = createHttpLink({
  uri: GQL_ROOT,
})

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  }
})

const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
}

export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  defaultOptions,
  resolvers,
})

const addToken = (passedToken?: string) => (req: Request) => {
  if (token) {
    req.set('Authorization', `Bearer ${token}`)
  }

  if (passedToken) {
    req.set('Authorization', `Bearer ${passedToken}`)
  }
}

export const setToken = (_token: string) => {
  token = _token
}

export const requests = {
  del: (path: string, passedToken?: string) =>
    superagent.del(getEndpoint(path)).use(addToken(passedToken)).then(responseBody),
  get: (path: string, passedToken?: string) =>
    superagent.get(getEndpoint(path)).use(addToken(passedToken)).then(responseBody),
  put: (path: string, body: any, passedToken?: string) =>
    superagent.put(getEndpoint(path), body).use(addToken(passedToken)).then(responseBody),
  postRaw: (path: string, body: any, passedToken?: string) =>
    superagent.post(getEndpoint(path), body).accept('json').use(addToken(passedToken)),
  post: (path: string, body: any, passedToken?: string) =>
    requests.postRaw(path, body, passedToken).then(responseBody),
}
